import Vue from 'vue'
import VueScrollShow from 'vue-scroll-show'
import { VueIntegrationLibrary } from '@adtelligence/vue-integration-library'
import { cxConfiguration, projectConfig } from '@/js/config'
import App from './App.vue'
import { getLanguage, initVariationTracking, storeTranslations } from '@/js/helpers'
import { GOALS } from '@/js/constants'

Vue.use(VueScrollShow)

storeTranslations(getLanguage())

const noSetupFoundCallback = function (integrationInstance) {
  integrationInstance.addConfigToTrackAfterConsentIsGiven({ goalId: GOALS.no_setup_found })
  integrationInstance.getTrackingInstance().executeTrackingQueue()
}

export const integrationInstance = new VueIntegrationLibrary(cxConfiguration, projectConfig, App, noSetupFoundCallback)

integrationInstance.setAfterMatomoIsLoadedCallback(() => {
  initVariationTracking(integrationInstance.getTrackingInstance())
})
